<template>
    <div class="">

        <div class="modal" :id="compModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-center">
                            Create Vehicle
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body bg-light" style="">
                        <div class="block block-rounded mb-0">
                            <div class="block-content block-content-full">

                                <fieldset>
                                    <div class="form-group mb-2">
                                        <CustomerSelect
                                            :customer="form.selectedCustomer"
                                            :required="true"
                                            remove-margin
                                        />
                                    </div>

                                    <div class="form-group mb-2">
                                        <label for="">
                                            <strong>
                                                Vehicle ID (Registration or VIN)
                                            </strong>
                                            <span class="text-danger">*</span>
                                        </label>

                                        <input
                                            class="form-control"
                                            v-model="form.reg"
                                            placeholder="Registration or Vehicle ID"
                                            type="text"
                                        >
                                    </div>

                                    <div class="form-group mb-2">
                                        <label for="">
                                            <strong>
                                                Colour (optional)
                                            </strong>
                                        </label>

                                        <input
                                            class="form-control"
                                            v-model="form.colour"
                                            placeholder="Colour"
                                            type="text"
                                        >
                                    </div>

                                    <div class="form-group mb-2">
                                        <label for="">
                                            <strong>
                                                Make (optional)
                                            </strong>
                                        </label>

                                        <input
                                            class="form-control"
                                            v-model="form.make"
                                            placeholder="Make"
                                            type="text"
                                        >
                                    </div>

                                    <div class="form-group mb-2">
                                        <label for="">
                                            <strong>
                                                Model (optional)
                                            </strong>
                                        </label>

                                        <input
                                            class="form-control"
                                            v-model="form.model"
                                            placeholder="Model"
                                            type="text"
                                        >
                                    </div>

                                    <div class="form-group mb-2">

                                        <VehicleTypeSelect
                                            v-model="form.selectedVehicleType"
                                            :required="true"
                                            remove-margin
                                        />

                                    </div>

                                </fieldset>

                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal">Close</button>

                        <button type="button" class="btn btn-primary" @click="createNewVehicleRequest" >Save</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from 'axios';
import { successAlert, errorAlert } from '@/utils';
import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";
import VehicleTypeSelect from "@/components/movements/components/VehicleTypeSelect.vue";
import { useId, reactive } from "vue";

const props = defineProps({
    vehicle: {
        type: Object,
        default: () => ({}),
    },
    customer: {
        type: Object,
        default: () => ({}),
    },
    identifier: {
        type: String,
        default: () => `vehicle-modal-${useId()}`,
    },
});
const emit = defineEmits(['vehicle-created']);

const form = reactive({
    selectedCustomer: props.customer || null,
    selectedVehicleType: props.vehicle?.vehicleType || null,
    reg: props.vehicle?.reg || null,
    colour: props.vehicle?.colour || null,
    make: props.vehicle?.make || null,
    model: props.vehicle?.model || null,
});

const compModal = props.identifier + '_vehicle_modal';

function resetForm() {
    form.selectedCustomer = props.customer || null;
    form.selectedVehicleType = null;
    form.reg = '';
    form.colour = '';
    form.make = '';
    form.model = '';
}

function createNewVehicleRequest() {
    const data = {
        customer_id: form.selectedCustomer?.id,
        reg: form.reg,
        colour: form.colour,
        make: form.make,
        model: form.model,
        vehicletype_id: form.selectedVehicleType?.id,
    };
    axios.post(route('api.movements.vehicles.store'), data)
        .then(response => {
            emit('vehicle-created', response.data);
            successAlert('Vehicle Created!', 'Success');
            resetForm();
            window.jQuery('.modal-header .btn-close').click();
        })
        .catch(error => {
            errorAlert(error, 'Error Creating Vehicle');
        });
}
</script>
